import { TextArea } from '@agro-club/agroclub-shared'
import { useAFormHandler } from 'analytics/hooks'
import { useFormik } from 'formik'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import {
  ASharedModal,
  SharedModalContent,
  SharedModalFooter,
  SharedModalInputs,
  SharedModalTitle,
} from 'views/components/SharedModal'
import { SampleWithRequests } from 'views/pages/Samples/types'
import { AButton } from 'views/components/Analytics'
import { prepareLogisticianText } from '../helpers'
import { Deal } from 'modules/domain/deal/types'

type Props = {
  deal: Deal
  sample?: SampleWithRequests
  onSuccess: () => Promise<void>
  onClose: () => void
}

export const PublishToCarriersChannelModal: FC<Props> = ({ onClose, onSuccess, deal, sample }) => {
  const { t } = useTranslation('deal')
  const { formProgress, formHandler } = useAFormHandler('publishToCarriers')

  const formik = useFormik({
    initialValues: {
      message_text: prepareLogisticianText(deal, sample) || '',
    },

    onSubmit: formHandler(
      async () => {
        await apiClient.put(
          endpoints.LogisticsKR.publishOffer(deal.logistics_request_id?.toString() || ''),
          formik.values,
        )
      },
      {
        onSuccess: async () => {
          await onSuccess()
          onClose()
        },

        onError: (error) => {
          formik.setErrors(error.errors)
        },
      },
    ),
  })

  return (
    <ASharedModal size="medium" onClose={onClose} id="PublishToCarriers">
      <SharedModalTitle>{t('send_logistics_request')}</SharedModalTitle>
      <SharedModalContent>
        <SharedModalInputs>
          <TextArea
            height={500}
            value={formik.values.message_text}
            onChange={(e) => formik.setFieldValue('message_text', e.target.value)}
          />
        </SharedModalInputs>
      </SharedModalContent>
      <SharedModalFooter>
        <AButton id="send" size="big" progress={formProgress} color="primary" onClick={formik.submitForm}>
          {t('common:send')}
        </AButton>
        <AButton id="cancel" size="big" onClick={onClose} color="secondary">
          {t('common:cancel')}
        </AButton>
      </SharedModalFooter>
    </ASharedModal>
  )
}
